import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class Utilities {

    S3DomainURL = environment.s3DomainURL;

    public getS3DownloadURL(): string {
        let s3DownloadURL = `${this.S3DomainURL}`;
        s3DownloadURL = `${this.S3DomainURL}templates/`;
        // if (!environment.production) {
        //     s3DownloadURL = `${this.S3DomainURL}templates/`;
        // }
        return s3DownloadURL;
    }

    focusFirstElement(form: FormGroup): void {
        const formControls = Object.keys(form.controls);
    
        for (let control of formControls) {
            const formControl = form.get(control);
            const $element = $(`[formControlName="${control}"]`);
            // console.log(formControl);
            // Skip if the control is disabled or the element doesn't exist
            if (formControl?.disabled || !$element.length) {
                continue;
            }
    
            if ($element.hasClass('ng-select')) {
                const $inputElement = $element.find('input');
                if ($inputElement.length) {
                    $inputElement.focus();
                    break; // Focus on the first enabled element
                }
            } else {
                $element.focus();
                break; // Focus on the first enabled element
            }
        }
    }


    public FormatDateWithTime(
        monthsOffset: number = 0, // Parameterized monthsOffset, default is 0 (no offset)
        date?: any
    ): {
        dateString: string,
        dateTimeString: string,
        dateTimeStringAMPM: string
    } {
        // Use the input date or fallback to current date if the input date is invalid or null
        let inputDate: Date = new Date(date);

        // If the date is invalid (e.g., new Date(undefined) gives "Invalid Date"), use the current date
        if (isNaN(inputDate.getTime())) {
            inputDate = new Date();
        }

        // Adjust the date based on the monthsOffset
        inputDate.setMonth(inputDate.getMonth() + monthsOffset);

        // Extract date components
        const year: string = inputDate.getFullYear().toString();
        const month: string = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day: string = inputDate.getDate().toString().padStart(2, '0');
        const hh: string = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours().toString();
        const mm: string = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes().toString();
        const ss: string = inputDate.getSeconds() < 10 ? ('0' + inputDate.getSeconds()) : inputDate.getSeconds().toString();

        // Format for AM/PM
        let hours: number = inputDate.getHours();
        const ampm: string = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // The hour '0' should be '12'
        const formattedHours: string = hours.toString().padStart(2, '0');

        // Generate the formatted date and time strings
        const dateTimeString: string = `${year}-${month}-${day}T${hh}:${mm}:${ss}`;
        const dateTimeStringAMPM: string = `${day}-${month}-${year} ${formattedHours}:${mm} ${ampm}`;
        const dateString: string = `${year}-${month}-${day}`;

        return { dateString, dateTimeString, dateTimeStringAMPM };
    }


    // usage: const result = FormatDateWithTime(-1).dateTimeString;

    public formatDate(date?: any, format: string = 'dd-mm-yyyy') {
        let inputDate: Date | null = null;
    
        try {
            if (date) {
                if (format) {
                    date = date.trim(); // Remove spaces from input
    
                    if (format.toLowerCase() === 'dd-mm-yyyy' || format.toLowerCase() === 'dd/mm/yyyy') {
                        const separator = date.includes('-') ? '-' : '/';
                        const [day, month, year] = date.split(separator).map(part => parseInt(part, 10));
                        inputDate = new Date(year, month - 1, day);
                    } else if (format.toLowerCase() === 'mm-dd-yyyy' || format.toLowerCase() === 'mm/dd/yyyy') {
                        const separator = date.includes('-') ? '-' : '/';
                        const [month, day, year] = date.split(separator).map(part => parseInt(part, 10));
                        inputDate = new Date(year, month - 1, day);
                    } else {
                        inputDate = new Date(date);
                    }
                } else {
                    inputDate = new Date(date);
                }
            } else {
                inputDate = new Date(); // Default to current date
            }
    
            // Check if inputDate is valid
            if (!inputDate || isNaN(inputDate.getTime())) {
                console.error("Invalid date:", date);
                return null;
            }
        } catch (err) {
            console.error("Error formatting date:", err);
            return null;
        }
    
        // Extract formatted date components
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
        const hours = inputDate.getHours();
        const minutes = inputDate.getMinutes().toString().padStart(2, '0');
        const seconds = inputDate.getSeconds().toString().padStart(2, '0');
    
        // Format for 12-hour clock with AM/PM
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
    
        const dateString = `${day}-${month}-${year}`;
        const dateTimeString = `${day}-${month}-${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
        const dateTime24HrString = `${day}-${month}-${year} ${hours.toString().padStart(2, '0')}:${minutes}:${seconds}`;
    
        return { dateString, dateTimeString, dateTime24HrString };
    }
    

    public getFormattedDate(d: Date, locale: string = 'hi-IN') {
        return {
            dateString: d.toLocaleDateString(locale),
            dateTimeString: d.toLocaleString(locale)
        }
    }


    public GetTitleForUrl(value: string): string {
        return value.replace(/\s/g, '-').toLowerCase();
    }

    public static status(value: any): string {
        if (!value) {
            return `<span class="badge bg-dark">NA</span>`;
        }
        if (typeof value === 'object') {
            value = value?.value;
        }
    
        let statusHtml = `<span class="badge bg-light">${value}</span>`;
        switch (value) {
            case 'SHIPMENT_BOOKED':
                statusHtml = `<span class="badge bg-light">BOOKED</span>`;
                break;
            case 'SHIPMENT_RECEIVED':
                statusHtml = `<span class="badge bg-primary">RECEIVED</span>`;
                break;
            case 'SHIPMENT_PARTIALLY_RECEIVED':
                statusHtml = `<span class="badge bg-primary">PARTIALLY RECEIVED</span>`;
                break;
            case 'SHIPMENT_PARTIALLY_BAGGED':
                statusHtml = `<span class="badge bg-info">PARTIALLY BAGGED</span>`;
                break;
            case 'SHIPMENT_BAGGED':
                statusHtml = `<span class="badge bg-info">BAGGED</span>`;
                break;
            case 'SHIPMENT_PARTIALLY_MANIFESTED':
                statusHtml = `<span class="badge bg-info">PARTIALLY MANIFESTED</span>`;
                break;
            case 'SHIPMENT_MANIFESTED':
                statusHtml = `<span class="badge bg-info">MANIFESTED</span>`;
                break;
            case 'SHIPMENT_SENT':
                statusHtml = `<span class="badge bg-info">SENT</span>`;
                break;
            case 'SHIPMENT_MISROUTED':
                statusHtml = `<span class="badge bg-danger">MISROUTED</span>`;
                break;
            case 'OUT_FOR_DELIVERY':
                statusHtml = `<span class="badge bg-warning">OUT FOR DELIVERY</span>`;
                break;
            case 'SHIPMENT_PARTIALLY_DELIVERED':
                statusHtml = `<span class="badge bg-warning">PARTIAL DELIVERED</span>`;
                break;
            case 'SHIPMENT_DELIVERED':
                statusHtml = `<span class="badge bg-success">DELIVERED</span>`;
            case 'SHIPMENT_INTRANSIT':
                statusHtml = `<span class="badge bg-success-subtle text-dark">IN-TRANSIT</span>`;
                break;
            default:
                const splitValue = value?.split('_') || "";
                statusHtml = `<span class="badge bg-dark">${splitValue?.length > 1 ? splitValue?.[1] : value}</span>`;
                break;
        }
        return statusHtml;
    }

    public static progressStat(status: string, location: string) {
        let transactionStatus = ['SHIPMENT_BOOKED', 'SHIPMENT_RECEIVED', 'SHIPMENT_PARTIALLY_RECEIVED', 'SHIPMENT_PARTIALLY_BAGGED', 'SHIPMENT_BAGGED',
            'SHIPMENT_PARTIALLY_MANIFESTED', 'SHIPMENT_MANIFESTED', 'SHIPMENT_SENT', 'SHIPMENT_MISROUTED', 'OUT_FOR_DELIVERY',
            'SHIPMENT_PARTIALLY_DELIVERED', 'SHIPMENT_DELIVERED', 'SHIPMENT_INTRANSIT'];
        const statusHtml = this.status(status);
        const baseSentence = `Shipment ${statusHtml}`
        let locationSentence = location ? ` at ${location}` : ' ';

        if (transactionStatus.includes(status)) {
            if (status == 'SHIPMENT_SENT' || status == 'OUT_FOR_DELIVERY') {
                locationSentence = location ? ` to ${location}` : ' ';
            }
        }
        return baseSentence + locationSentence;
    }

    // minDateValidator(minDate?: Date) {
    //     const minDateWithoutTime = minDate
    //         ? new Date(minDate.setHours(0, 0, 0, 0))
    //         : new Date(new Date().setHours(0, 0, 0, 0));

    //     return (control: any) => {
    //         if (!control.value) {
    //             return null;
    //         }
    //         const inputDate = new Date(control.value);
    //         const inputDateWithoutTime = new Date(inputDate.setHours(0, 0, 0, 0));
    //         return inputDateWithoutTime < minDateWithoutTime ? { minDate: true } : null;
    //     };
    // }

    minDateValidator(minDate?: Date) {
        const minDateWithoutTime = minDate
            ? new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate())
            : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    
        return (control: any) => {
            if (!control.value) {
                return null;
            }
            const inputDate = new Date(control.value);
            const inputDateWithoutTime = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
    
            return inputDateWithoutTime < minDateWithoutTime ? { minDate: true } : null;
        };
    }

    getMaxLength(pattern: RegExp): number {
        // Match the full postal code including the optional hyphen part
        const matched = pattern.toString().match(/\d+/g); // Match digit groups

        // Match only the hyphen '-' character (as the non-digit separator)
        const nonDigitMatches = pattern.toString().match(/-/g);  // Only match hyphens

        if (matched) {
            // Return the maximum length of digit groups plus the length of hyphens if present
            const digitLength = Math.max(...matched.map(Number));  // Maximum digit length
            const hyphenLength = nonDigitMatches ? nonDigitMatches.length : 0;  // Count of hyphens

            // For example, 90210-1234 should return 10 (5 digits + 1 hyphen + 4 digits)
            return digitLength + hyphenLength * 5;  // The hyphen adds a fixed length of 5 when present
        }

        return 15;
    }

    getMinLength(pattern: RegExp): number {
        const matched = pattern.toString().match(/\d+/g); // Match digit groups
        if (matched) {
            // Return the minimum length of digit groups plus the length of hyphens if present
            const digitLength = Math.min(...matched.map(Number));  // Minimum digit length
            return digitLength;
        }
        return 0;
    }

    closeCurrentAndFocusNext(currentElementToClose: NgSelectComponent, nextElementToFocus: any): void {
        // Check if currentElement is an instance of NgSelectComponent
        if (currentElementToClose instanceof NgSelectComponent) {
            currentElementToClose.close();  // Close the current ng-select
        }
        if (nextElementToFocus instanceof NgSelectComponent) {
            nextElementToFocus.close();  // Close the current ng-select
        }
        nextElementToFocus.focus();
    };

    getFormattedDocType(filetype: 'application/pdf' | 'image/jpeg' | 'image/png' | 'text/csv'): string {
        if (!filetype) return 'UNKNOWN';

        const typeMap: { [key: string]: string } = {
            'application/pdf': 'PDF Document',
            'image/jpeg': 'JPEG Image',
            'image/png': 'PNG Image',
            'text/csv': 'CSV File'
        };

        return typeMap[filetype] || filetype.split('/').pop()?.toUpperCase() || 'UNKNOWN';
    }
}
